
import { Password as PrimereactPassword } from 'primereact/password';
import { ReactComponent as EyeIcon } from '../../assets/images/eye-icon.svg';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';
import { useRef } from 'react';
import { classNames } from 'primereact/utils';

const Password = ({showLabel = true, label, validator, validations, ...rest}) => {
    const ref = useRef();
    const id = `passwd-${rest.id}`;
    const validationMessage = validator ? validator.message(id, label, rest.value, validations) : null;
    return (
        <div className="field">
            {showLabel && <label htmlFor={id}>{label}</label>}
            <PrimereactPassword {...rest} id={id} ref={ref} toggleMask className={classNames('w-full', {'p-invalid': validationMessage})} inputClassName='w-full' panelClassName='hidden'
                icon={<EyeIcon className='p-icon p-password-show-icon' onClick={() => ref.current.toggleMask()}/>}
            />
            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon'/>
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    )
}

export default Password;